module.exports = __webpack_public_path__ + "static/media/3.3804e0bc.jpg";